import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import MessageInput from '@classify/react-product-components/Chatbot/MessageInput';
import Stack from '@classify/react-core-components/Stack';
import ConversationStarterButton from '@classify/react-product-components/ConversationStarterButton';
import TitleSeparator from '../TitleSeparator';
interface Props {
  onSendMessage?: (message: string) => void;
}
export default function Companion(t0) {
  const $ = _c(26);
  const {
    onSendMessage
  } = t0;
  let t1;
  if ($[0] !== onSendMessage) {
    t1 = value => {
      onSendMessage?.(value);
    };
    $[0] = onSendMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSend = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("iabot.conversation.placeholder.support.enrollment");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleSend) {
    t3 = <MessageInput onSend={handleSend} placeholder={t2} />;
    $[3] = handleSend;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TitleSeparator>{translate("support.global.faq.title")}</TitleSeparator>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translate("iabot.conversation.starter.support.question.funding_options");
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleSend) {
    t6 = <ConversationStarterButton onClick={handleSend}>{t5}</ConversationStarterButton>;
    $[7] = handleSend;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = translate("iabot.conversation.starter.support.request.training_cost");
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleSend) {
    t8 = <ConversationStarterButton onClick={handleSend}>{t7}</ConversationStarterButton>;
    $[10] = handleSend;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = translate("iabot.conversation.starter.support.request.prerequisites");
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== handleSend) {
    t10 = <ConversationStarterButton onClick={handleSend}>{t9}</ConversationStarterButton>;
    $[13] = handleSend;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = translate("iabot.conversation.starter.support.request.training_content");
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== handleSend) {
    t12 = <ConversationStarterButton onClick={handleSend}>{t11}</ConversationStarterButton>;
    $[16] = handleSend;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12 || $[20] !== t6 || $[21] !== t8) {
    t13 = <div>{t4}{t6}{t8}{t10}{t12}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t6;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t3) {
    t14 = <Stack spacing={4}>{t3}{t13}</Stack>;
    $[23] = t13;
    $[24] = t3;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}